export default __webpack_public_path__ + "static/img1-11aa3e79a424a8480f7a5a699bae252f.png";